import React from 'react';

import { ChatbotUIBasicProps } from '@/types/common';
import { FOOD_ORDER_CREATED_AT_TEXT, FOOD_ORDER_TODAY_TEXT, FOOD_TOTAL_TEXT } from '@/utils/constants';
import { formatPrice, getTrans } from '@/utils/tools';
import dateLib from '@/utils/dateLib/moment';
import { Order as UIOrder } from '@shopee/chatbot-ui';
import { OrderProps } from '@shopee/chatbot-ui/lib/components/Order';
import { OrderCardType } from '@shopee/chatbot-ui/lib/components/OrderList';

export type FoodBuyerOrderProps = OrderProps & ChatbotUIBasicProps & { handlerType: HandlerType };

export enum HandlerType {
  NoNeedHandleParam,
  NeedHandleParam,
}

interface PropsInUnderScore {
  create_time?: number;
  total_price?: string;
}

export const formatTime = (time: number) => {
  return dateLib.isToday(time)
    ? `${getTrans(FOOD_ORDER_CREATED_AT_TEXT)} ${getTrans(FOOD_ORDER_TODAY_TEXT)} ${dateLib.format(time, 'HH:ii')}`
    : `${getTrans(FOOD_ORDER_CREATED_AT_TEXT)} ${dateLib.format(time, 'DD-MM-YYYY HH:ii')}`;
};

const FoodBuyerOrder = (props: FoodBuyerOrderProps & PropsInUnderScore) => {
  const { handlerType = HandlerType.NeedHandleParam, total_price, create_time, image } = props;
  const commonParams = { totalText: getTrans(FOOD_TOTAL_TEXT), orderCardType: OrderCardType.foodCard };

  const foodBuyerOrderParams =
    handlerType === HandlerType.NeedHandleParam
      ? {
        ...props,
        totalPrice: formatPrice(total_price),
        createdTime: formatTime(create_time || 0),
      }
      : props;

  return <UIOrder {...foodBuyerOrderParams} {...commonParams} />;
};

export default FoodBuyerOrder;
